import { render } from "./gradientbadges.vue?vue&type=template&id=494c54bc"
import script from "./gradientbadges.vue?vue&type=script&lang=js"
export * from "./gradientbadges.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__